import { AddressDto } from "./addressDto";
import { CartItem } from "./cartItem";

export class Cart {
	public cartItems: Array<CartItem> = new Array<CartItem>();

	public deliveryAddress: AddressDto = new AddressDto();
	public invoiceAddress: AddressDto = new AddressDto();
	public hasChanged: boolean = false;
}
